import {
  Sheet,
  SheetContentResizable,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { useLocalStorageValue } from '@react-hookz/web';
import {
  EntityDetailTabsProvider,
  EntityDetailTabsHeader,
  EntityDetailTabsContent,
  useEntityDetailTabsContext,
} from '@/components/accounts-payable/shared/entity-detail-tabs';
import { SystemEntity } from '@erp/shared-types';
import { Tabs } from '@/components/ui/tabs';

function PurchaseOrderDetailTabsWrapper() {
  const { activeTabId, setActiveTabId } = useEntityDetailTabsContext();
  return (
    <Tabs
      value={activeTabId}
      onValueChange={setActiveTabId}
      className="flex flex-col flex-1 min-h-0"
    >
      <SheetHeader className="shrink-0 grow-0 border-b px-3 py-3">
        <EntityDetailTabsHeader />
      </SheetHeader>
      <div className="flex-1 min-h-0 overflow-hidden">
        <EntityDetailTabsContent />
      </div>
    </Tabs>
  );
}

export function PurchaseOrderDetailSlidein({
  isOpen,
  onOpenChange,
  purchaseOrderId,
}: {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  purchaseOrderId?: string;
}) {
  const { value: detailViewSize, set: setDetailViewSize } =
    useLocalStorageValue<number>('purchase-order-detail-view-size', {
      defaultValue: 50,
    });

  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContentResizable
        resizableProps={{
          defaultSize: detailViewSize,
          onResize: setDetailViewSize,
          className: 'flex flex-col',
        }}
      >
        {purchaseOrderId ? (
          <EntityDetailTabsProvider
            initialEntity={{
              entityType: SystemEntity.INTERNAL_PURCHASE_ORDER,
              entityId: purchaseOrderId,
            }}
          >
            <PurchaseOrderDetailTabsWrapper />
          </EntityDetailTabsProvider>
        ) : (
          <>
            <SheetHeader className="shrink-0 grow-0">
              <SheetTitle>Purchase Order Details</SheetTitle>
            </SheetHeader>
            <div className="p-4 text-sm text-muted-foreground">
              No purchase order selected
            </div>
          </>
        )}
        <SheetFooter className="shrink-0 grow-0 flex items-end border-t">
          <Button
            onClick={() => {
              onOpenChange(false);
            }}
            className="w-fit"
          >
            Close
          </Button>
        </SheetFooter>
      </SheetContentResizable>
    </Sheet>
  );
}
